module.exports = __webpack_public_path__ + "img/14.17b55018.jpg";